import {fetchBankAccounts} from "@/public/store/modules/sepaSwift/actions/fetchBankAccount";
import {createBankAccount} from "@/public/store/modules/sepaSwift/actions/createAccount";
import {fetchBankAccountValidationData} from "@/public/store/modules/sepaSwift/actions/getBankAccountValidationData";

export const actions = {
    fetchBankAccounts,
    createBankAccount,
    fetchBankAccountValidationData
};
